export default __webpack_public_path__ + "static/media/house.8d28f18c.png";